<script setup lang="ts">
import EpaperCardBlock from './EpaperCardBlock.vue'
const { t } = useTranslation()
const authStore = useAuthStore()

const card1Text = computed(() => authStore.isAuthenticated ? t('epaper.landingPage.cardBlock.user.1') : t('epaper.landingPage.cardBlock.guest.1'))
const card2Text = computed(() => authStore.isAuthenticated ? t('epaper.landingPage.cardBlock.user.2') : t('epaper.landingPage.cardBlock.guest.2'))
const card3Text = computed(() => authStore.isAuthenticated ? t('epaper.landingPage.cardBlock.user.3') : t('epaper.landingPage.cardBlock.guest.3'))
</script>

<template>
  <div>
    <IaHeading
      :level="3"
      as:="h2"
      font-700
      mb-6
    >
      {{ t('epaper.landingPage.heading.2') }}
    </IaHeading>
    <div flex="~ col lg:row gap-4">
      <EpaperCardBlock>
        <div
          mx-auto
        >
          <IaThemeIcon
            icon="i-fas:user"
            size="2xl"
            class="text-grey-800 bg-primaryBeige-100"
          />
        </div>
        <div
          mt-4
          font-400
          text-center
          v-html="card1Text"
        >
        </div>
      </EpaperCardBlock>

      <EpaperCardBlock>
        <div mx-auto>
          <IaThemeIcon
            icon="i-fas:check"
            size="2xl"
            class="text-grey-800 bg-primaryBeige-100"
          />
        </div>
        <div
          mt-4
          font-400
          text-center
          v-html="card2Text"
        >
        </div>
      </EpaperCardBlock>

      <EpaperCardBlock>
        <div mx-auto>
          <IaThemeIcon
            icon="i-fas:envelope"
            size="2xl"
            class="text-grey-800 bg-primaryBeige-100"
          />
        </div>
        <div
          mt-4
          font-400
          text-center
          v-html="card3Text"
        >
        </div>
      </EpaperCardBlock>
    </div>
  </div>
</template>
